import { useEffect, useState } from 'react';

/** Live `prefers-reduced-motion: reduce`, re-rendering when the OS setting flips. */
export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    try { return !!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches; } catch { return false; }
  });
  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (!mq) return undefined;
    setReduced(mq.matches);
    const on = (e) => setReduced(e.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  return reduced;
}
